export enum StateType {
  Local = 'local',
  User = 'user',
  Account = 'account',
  PlatformUsers = 'platformusers',
  AllUsers = 'allusers',
  Device = 'device',
  Public = 'public',
  Platform = 'platform'
}

export class AuthInfo {
  success?: boolean;

  user?: string;
  userToken?: string;
  account?: string;
  platform?: string;
  salesmeeting?: string;
  aki?: string;
  akey?: string;
  owner?: string;
  ownerType?: string;

  authType?: string;
}

export class StateModel {
  id?: number;
  key?: string;
  fullKey?: string;
  data?: { [key: string]: any };
  updatedDate?: Date;
  entityType?: string;
  entityId?: string;
  description?: string;
  name?: string;
  createdDate?: Date;
  owner?: string;
  ownerType?: string;
  stateType?: string;
  compressionKey?: string;
  sessionId?: string;
}

export enum SubscriptionType {
  Live, // Receives only new values after subscription
  Latest, // Receives the last known value, then new ones
  Replay, // Receives the last N values, then new ones
  ReplayAll // Receives all values within the retention window, then new ones
}

export class SubscriptionOptions {
  subscriptionType?: SubscriptionType = SubscriptionType.Latest;
  replayCount?: number;
  replaySince?: Date;
}

export class StateMessage {
  data?: StateModel;
  auth?: AuthInfo;
  options?: SubscriptionOptions;
}

export class StateValueHistory {
  id: number;
  stateId: number;
  valueData: string;
  timestamp: Date;
  compressionKey?: string;
}
